import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background: white;
  max-width: 500px;
  margin: auto;
  border-radius: 10px;

  header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    img {
      margin: 30px;
    }
  }

  .container {
    max-width: 1200px;
    width: 100%;
    padding: 20px 20px;
    margin: auto;
    flex: 1;
  }

  .idv-start-form {
    max-width: 300px;
    margin: auto;

    .submit-button-wrapper {
      text-align: center;
      margin-top: 50px;
    }
  }

  .bank-connect-section {
    width: 100%;
    text-align: center;
  }

  p {
    margin-bottom: 20px;
    text-align: center;
  }

  footer {
    margin-top: 180px;

    .tifle-logo-wrapper {
      margin: 30px;
      padding: 5px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      div {
        margin-bottom: 5px;
        font-size: 11px;
      }

      img {
        width: 65px;
      }
    }
  }
`;
